import PropTypes from 'prop-types';
import React from 'react';
import withStyles from '@mui/styles/withStyles';

import * as dates from 'react-schedule-calendar/lib/utils/dates';
import { navigate } from 'react-schedule-calendar/lib/utils/constants';
import { inRange } from 'react-schedule-calendar/lib/utils/eventLevels';
import { isSelected } from 'react-schedule-calendar/lib/utils/selection';

const styles = () => ({
  event: {
    cursor: 'pointer',
  },
});

class WeekView extends React.Component {
  render() {
    let { date, events, accessors, localizer } = this.props;
    let { messages } = localizer;

    let firstOfWeek = localizer.startOfWeek();
    let start = dates.startOf(date, 'week', firstOfWeek);
    let end = dates.endOf(date, 'week', firstOfWeek);

    let range = WeekView.range(date, { localizer });

    events = events.filter(event => inRange(event, start, end, accessors));

    events.sort((a, b) => +accessors.start(a) - +accessors.start(b));

    return (
      <div className="rbc-agenda-view">
        {events.length !== 0 ? (
          <React.Fragment>
            <table ref={this.headerRef} className="rbc-agenda-table">
              <thead>
                <tr>
                  <th className="rbc-header" ref={this.dateColRef}>
                    {messages.date}
                  </th>
                  <th className="rbc-header">{messages.event}</th>
                </tr>
              </thead>
              <tbody ref={this.tbodyRef}>
                {range.map((day, idx) => this.renderDay(day, events, idx))}
              </tbody>
            </table>
          </React.Fragment>
        ) : (
          <span className="rbc-agenda-empty">{messages.noEventsInRange}</span>
        )}
      </div>
    );
  }

  renderDay = (day, events, dayKey) => {
    let {
      classes,
      selected,
      getters,
      accessors,
      localizer,
      components: { event: Event, date: AgendaDate },
      onSelectEvent,
    } = this.props;

    events = events.filter(e =>
      inRange(e, dates.startOf(day, 'day'), dates.endOf(day, 'day'), accessors)
    );

    return events.map((event, idx) => {
      let title = accessors.title(event);
      let end = accessors.end(event);
      let start = accessors.start(event);

      const userProps = getters.eventProp(
        event,
        start,
        end,
        isSelected(event, selected)
      );

      let dateLabel = idx === 0 && localizer.format(day, 'agendaDateFormat');
      let first =
        idx === 0 ? (
          <td rowSpan={events.length} className="rbc-agenda-date-cell">
            {AgendaDate ? (
              <AgendaDate day={day} label={dateLabel} />
            ) : (
              dateLabel
            )}
          </td>
        ) : (
          false
        );

      return (
        <tr
          key={dayKey + '_' + idx}
          className={userProps.className}
          style={userProps.style}
        >
          {first}
          <td className="rbc-agenda-event-cell">
            {Event ? (
              <Event
                className={classes.event}
                event={event}
                title={title}
                onSelect={onSelectEvent}
              />
            ) : (
              title
            )}
          </td>
        </tr>
      );
    }, []);
  };
}

WeekView.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
};

WeekView.navigate = (date, action) => {
  switch (action) {
    case navigate.PREVIOUS:
      return dates.add(date, -1, 'week');

    case navigate.NEXT:
      return dates.add(date, 1, 'week');

    default:
      return date;
  }
};

WeekView.range = (date, { localizer }) => {
  let firstOfWeek = localizer.startOfWeek();
  let start = dates.startOf(date, 'week', firstOfWeek);
  let end = dates.endOf(date, 'week', firstOfWeek);

  return dates.range(start, end);
};

WeekView.title = (date, { localizer }) => {
  let [start, ...rest] = WeekView.range(date, { localizer });
  return localizer.format({ start, end: rest.pop() }, 'dayRangeHeaderFormat');
};

export default withStyles(styles)(WeekView);
